import { render, staticRenderFns } from "./form-weight-dims.vue?vue&type=template&id=5029c9d1&scoped=true"
import script from "./form-weight-dims.vue?vue&type=script&lang=js"
export * from "./form-weight-dims.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5029c9d1",
  null
  
)

export default component.exports